import { ReactComponent as ExclamationIcon } from 'assets/icon/exclamation.svg';
import { useAppSelector, useAppDispatch } from 'hooks/useAppDispatchSelector';
import PrimaryDarkButton from 'components/common/buttons/primary-dark-btn';
import DarkButton from 'components/common/buttons/dark-btn';
import { setModal } from 'store/features/modelSlice';
import { initModal } from 'helpers/utils';
import { useTranslation } from 'react-i18next';

const Confirmation = () => {
  const { modal } = useAppSelector(state => state.modal);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { content } = modal;
  const handleDelete = () => {
    const { callBackFun } = content;
    if (callBackFun) {
      callBackFun();
    }
  };
  return (
    <div className="flex flex-col w-full h-full max-w-[450px]">
      <div className="flex flex-col w-full gap-y-3">
        <div className="flex items-center w-full gap-x-1">
          <ExclamationIcon height={40} width={40} />
          <label className="text-xl font-semibold text-black2 whitespace-nowrap overflow-hidden flex-1 text-ellipsis">
            {content?.title}
          </label>
        </div>
        <label className="text-base break-words font-medium text-grey9">{content?.message}</label>
        <div className="flex items-center justify-center w-full gap-x-4 mt-5">
          <PrimaryDarkButton
            label={t('DELETE')}
            onClick={() => handleDelete()}
            width="w-1/2"
            background="bg-red-600"
          />
          <DarkButton
            label={t('CANCEL')}
            width="w-1/2"
            onClick={() => dispatch(setModal(initModal))}
          />
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
